module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_01@3x-c9a3e7ff2fa9dd526d750c2c043c8fab.webp";